import { httpRequest } from '@/apis/request'

enum Apis {
  getAllMatCode = 'load_plank_mat_code',
}

export async function fetchAllMatCode(params: any) {
  return httpRequest.post(Apis.getAllMatCode, params)
}
